import loyaltyApi from '../services/loyaltyApi';
import api from '../services/api';

const loyaltyService = {
    getUserLoyalty,
    getProgram,
};

export default loyaltyService;

function getUserLoyalty (userId) {
    const requestConfig = {
        url: `/users/${userId}`,
        method: 'GET',
        resolves: [{
            status: 404,
            data: null,
        }],
    };

    return loyaltyApi(requestConfig);
}

async function getProgram (apiKey) {
    const result = await Promise.allSettled([
        loyaltyApi({
            url: `/programs/${apiKey}`,
            method: 'GET',
        }),
        api({
            url: `/loyalty/info`,
            method: 'GET',
        }),
    ]);

    return {
        ...result[0].value,
        ...{
            enabled: Boolean(result[1].value && result[1].value.yotpoEnabled),
            pointsLabel: result[1].value && result[1].value.yotpoPointsLabel || 'Points',
        },
    };
}
